module.exports = __webpack_public_path__ + "static/media/landingPage_image_mobile.9ae685ec.avif";